import { Code2, Smartphone, Settings2, Layers, Lightbulb, Check } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { services } from '@/constants/services'

const iconMap: Record<string, LucideIcon> = {
  Code2,
  Smartphone,
  Settings2,
  Layers,
  Lightbulb,
}

export function ServicesListSection() {
  return (
    <Section surface="0" withBorder>
      <Container>
        <div className="space-y-6 sm:space-y-10 md:space-y-12">
          {services.map((service, index) => {
            const Icon = iconMap[service.iconName] || Code2

            return (
              <div
                key={service.id}
                id={service.id}
                className="rounded-sm border border-border bg-surface-2 p-5 sm:p-8 md:p-10 transition-colors duration-200"
              >
                <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-6 sm:gap-8">
                  {/* Left Column: Title & Description */}
                  <div className="lg:max-w-xl">
                    <div className="flex items-center gap-2.5 mb-3 sm:mb-4">
                      <div className="flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-sm bg-surface-3 text-fg">
                        <Icon size={18} />
                      </div>
                      <span className="font-mono text-xs text-fg-muted">
                        // 0{index + 1}
                      </span>
                    </div>

                    <h2 className="text-lg sm:text-2xl font-bold tracking-tight text-fg">
                      {service.title}
                    </h2>

                    <p className="mt-2.5 sm:mt-4 text-sm sm:text-base text-fg-subtle leading-relaxed">
                      {service.description}
                    </p>

                    <div className="mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-border-subtle">
                      <span className="text-xs font-semibold uppercase tracking-wider text-fg-muted block mb-1">
                        Ideal Fit
                      </span>
                      <p className="text-sm text-fg-subtle">
                        {service.idealFor}
                      </p>
                    </div>
                  </div>

                  {/* Right Column: Key Deliverables */}
                  <div className="lg:w-80 lg:shrink-0 rounded-sm bg-surface-1 p-4 sm:p-6 border border-border-subtle">
                    <span className="text-xs font-semibold uppercase tracking-wider text-fg mb-3 sm:mb-4 block">
                      Key Deliverables
                    </span>
                    <ul className="space-y-2.5 sm:space-y-3 list-none p-0 m-0">
                      {service.deliverables.map((item) => (
                        <li key={item} className="flex items-start gap-2.5 text-xs sm:text-sm text-fg-subtle">
                          <Check size={15} className="text-fg mt-0.5 shrink-0" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </Section>
  )
}
